<template>
  <BaseDropDownMenu
    :title="$t('global.action')"
    size="small"
    :options="options"
  />
</template>

<script>
export default {
  name: 'InvoicingIndexActionDropDownComponent',
  emits: ['generate-invoices-pdf', 'generate-invoices-csv'],
  computed: {
    options() {
      return [
        {
          label: this.$t('button.generate_pdf_file'),
          icon: 'file-pdf',
          gate: true,
          action: () => this.$emit('generate-invoices-pdf')
        },
        {
          label: this.$t('button.generate_csv_file'),
          icon: 'file-csv',
          gate: true,
          action: () => this.$emit('generate-invoices-csv')
        },
        {
          label: this.$t('button.accounting_export'),
          icon: 'arrow-alt-from-left',
          // The crematorium's accounting, not a customer's.
          gate:
            this.$store.getters['auth/getAuthRole'] !== 'customer-user' &&
            this.$can('manage_invoicing'),
          action: () => this.$router.push({ name: 'invoice_export_route' })
        }
      ]
    }
  }
}
</script>
